/* eslint-disable import/no-extraneous-dependencies */
import React from 'react';
import { SyncStatusRow } from './SyncStatusRow';
const meta = {
    title: 'Features/Settings/Integrations/SyncStatusRow',
    component: SyncStatusRow,
    parameters: {
        layout: 'padded'
    },
    decorators: [
        (Story) => (React.createElement("div", { style: { maxWidth: '600px', margin: '40px auto' } },
            React.createElement(Story, null)))
    ]
};
export default meta;
export const Healthy = {
    args: {
        label: 'Materials & services',
        category: {
            category: 'materials',
            lastSuccessAt: '2025-06-10T12:00:00Z',
            lastErrorAt: null,
            lastErrorMessage: null
        },
        syncable: true
    }
};
export const Error = {
    args: {
        label: 'Materials & services',
        category: {
            category: 'materials',
            lastSuccessAt: '2025-06-08T10:00:00Z',
            lastErrorAt: '2025-06-10T14:30:00Z',
            lastErrorMessage: 'QuickBooks returned a 401 error'
        },
        syncable: true
    }
};
export const NeverSynced = {
    args: {
        label: 'Tax rates',
        category: {
            category: 'tax_rates',
            lastSuccessAt: null,
            lastErrorAt: null,
            lastErrorMessage: null
        },
        syncable: true
    }
};
export const NoAction = {
    args: {
        label: 'Payments from QuickBooks',
        category: {
            category: 'payments',
            lastSuccessAt: '2025-06-10T11:00:00Z',
            lastErrorAt: null,
            lastErrorMessage: null
        },
        syncable: false
    }
};
